export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11324.ac6dca20.jpg";